module.exports = __webpack_public_path__ + "static/media/a7.3aecffa.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sangwenfeng/a7.mp3
// module id = jq2Q
// module chunks = 0